import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopSearchResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopSearch = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.SearchRequest), switchMap(function (action) {
        return deps
            .netSend({
            id: CommandCode.SearchCoop,
            props: {
                name: action.name,
                playerId: action.playerId,
            },
        })
            .pipe(map(actionCoopSearchResponse), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopSearch.ts
// module id = 1823
// module chunks = 3